module.exports = __webpack_public_path__ + "static/media/photo-2-320.634d6720.png";